import Api from './rest/CompanyDepartmentMember';

export default new Api();
